<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/customers' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户等级</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-form :model="queryInfo" label-width="auto" size="small" class="search-form">
          <el-form-item label="用户等级：">
            <el-input v-model="queryInfo.userLevel" placeholder="等级名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn btn-gray" @click="handleReset">重置</el-button>
            <el-button class="search-btn btn-blue" @click="searchUserLevel">搜索</el-button>
            <el-button class="search-btn btn-green" @click="handleAdd">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :data="userLevelList"
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="{ 'text-align': 'center' }"
          border
          ref="multipleTable"
          height="550"
        >
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button v-if="scope.row.userSize <= 0" class="search-btn btn-blue" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.userSize <= 0" class="search-btn btn-red" @click="handleDel(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="userLevelName" label="用户等级"></el-table-column>
          <el-table-column prop="userSize" width="100" label="用户数量"></el-table-column>
          <el-table-column prop="openTime" label="启用时间" width="155"></el-table-column>
          <el-table-column prop="monthReduction" label="减免会员费期限" width="110"></el-table-column>
          <el-table-column prop="membershipFee" label="每月会员费（￥）">
            <template slot-scope="scope">
              {{ Number(scope.row.membershipFee).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="commission" width="150" label="代购手续费比率（%）"></el-table-column>
          <!--<el-table-column prop="rate" label="汇率附加比例"> </el-table-column>
          <el-table-column prop="creditLimit" label="会员信用额度（￥）">
            <template slot-scope="scope">
              {{ Number(scope.row.creditLimit).toLocaleString() }}
            </template>
          </el-table-column>-->
          <el-table-column prop="levelNote" label="等级说明" width="250"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 新增/编辑 -->
    <el-dialog title="用户等级配置" :visible.sync="visible" @close="handleCancel">
      <el-form label-width="160px" label-position="left" :model="levelInfo" ref="levelFormRef" size="small" :rules="levelRules" class="level-form">
        <el-form-item label="用户等级名称" prop="userLevelName">
          <el-input v-model="levelInfo.userLevelName" placeholder="输入用户等级名称，如：战略合作"></el-input>
        </el-form-item>
        <el-form-item label="减免会员费期限" prop="monthReduction">
          <el-input-number
            :controls="false"
            v-model="levelInfo.monthReduction"
            :min="0"
            :max="12"
            placeholder="输入0-12的数字，0代表不减免，最大减免12个月"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="每月会员费（￥）" prop="membershipFee">
          <el-input-number
            :controls="false"
            v-model="levelInfo.membershipFee"
            :precision="2"
            :step="0.1"
            placeholder="输入每月会员费金额"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="代购手续费比率（%）" prop="commission">
          <el-input-number :controls="false" v-model="levelInfo.commission" placeholder="输入代购手续费比率"></el-input-number>
        </el-form-item>
        <!--<el-form-item label="汇率附加比例" prop="rate">
          <el-input-number
            :controls="false"
            v-model="levelInfo.rate"
            :step="0.1"
            placeholder="输入汇率附加比例，如：0.2（代表在获得的标准汇率基础上增加0.2）"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="会员信用额度（￥）" prop="creditLimit">
          <el-input-number
            :controls="false"
            v-model="levelInfo.creditLimit"
            placeholder="输入会员信用额度，如：100,000（代表会员可以在平台上透支100,000）"
          ></el-input-number>
        </el-form-item>-->
        <el-form-item label="用户等级说明" prop="levelNote">
          <el-input type="textarea" :rows="3" resize="none" v-model="levelInfo.levelNote" placeholder="用户等级说明"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="handleCancel">取消</el-button>
        <el-button class="form-btn btn-blue" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";

export default {
  components: { tableCon },
  data() {
    return {
      queryInfo: {
        userLevel: "",
        pageSize: 10,
        pageNum: 1,
      },
      powerBtn: [],
      levelInfo: {
        userLevelName: "",
        levelNote: "",
        monthReduction: undefined,
        membershipFee: undefined,
        commission: undefined,
        rate: undefined,
        creditLimit: undefined,
      },
      levelRules: {
        userLevelName: [{ required: true, message: "用户等级名称为必填", trigger: "blur" }],
      },
      visible: false,
      isLoading: false,
      userLevelList: [],
      total: 0,
      submitUrl: "",
    };
  },
  created() {
    /*let permissionList = JSON.parse(window.sessionStorage.getItem("permissionList"));
    let curPath = this.$router.history.current.path.slice(1);
    permissionList.map((item) => {
      if (item.menuUrl == curPath) {
        this.powerBtn = item.btnAuth;
      }
    });*/
    this.getUserLevelList();
  },

  methods: {
    searchUserLevel() {
      this.queryInfo.pageNum = 1;
      this.queryInfo.pageSize = 10;
      this.getUserLevelList();
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getUserLevelList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getUserLevelList();
    },
    handleAdd() {
      this.visible = true;
      this.submitUrl = "user/level/saveAction";
    },
    handleReset() {
      this.queryInfo.userLevel = "";
      this.searchUserLevel()
    },
    async getUserLevelList() {
      this.isLoading = true;
      const { data: res } = await this.$http.get("user/level/page", {
        params: this.queryInfo,
      });
      console.log(res)
      this.userLevelList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false;
    },
    handleCancel() {
      const obj = this.levelInfo;
      const unNumberInfoKeyArr = ["userLevelName", "levelNote"];
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          if (unNumberInfoKeyArr.includes(key)) {
            this.levelInfo[key] = "";
          } else {
            this.levelInfo[key] = undefined;
          }
        }
      }
      this.visible = false;
    },
    handleSubmit() {
      this.$refs.levelFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = {};
        const unNumberInfoKeyArr = ["userLevelName", "levelNote"];
        for (const key in this.levelInfo) {
          if (Object.hasOwnProperty.call(this.levelInfo, key)) {
            if (!unNumberInfoKeyArr.includes(key) && this.levelInfo[key] === undefined) {
              params[key] = 0;
            } else {
              params[key] = this.levelInfo[key];
            }
          }
        }
        this.$http
          .post(this.submitUrl, params)
          .then(({ data: res }) => {
            if (res.code === 200) {
              this.visible = false;
              this.getUserLevelList();
              this.$message.success(res.data.message);
            }
          })
          .catch(({ data: res }) => {
            this.$message.error(res.data.message);
          });
      });
    },
    handleDel(id) {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("user/level/delete", {
              params: {
                id,
              },
            })
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
              }
              this.getUserLevelList();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleEdit(row) {
      this.submitUrl = "user/level/updateAction";
      for (const key in row) {
        if (Object.hasOwnProperty.call(row, key)) {
          if (key in this.levelInfo) {
            this.levelInfo[key] = row[key];
          }
        }
      }
      this.levelInfo.id = row.id;
      this.visible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.search-form {
  display: flex;
  justify-content: space-between;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}
.level-form {
  ::v-deep .el-input-number--small {
    width: 100%;
  }
  ::v-deep .el-input-number .el-input__inner {
    text-align: left
  }
}
</style>
